"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavItemSharedStylePropTypes = exports.SharedStylePropTypes = void 0;
var prop_types_1 = __importDefault(require("prop-types"));
exports.SharedStylePropTypes = {
    activeItemBackgroundColor: prop_types_1.default.string,
    activeItemFontColor: prop_types_1.default.string,
    activeItemIconColor: prop_types_1.default.string,
    backgroundColor: prop_types_1.default.string,
    divider: prop_types_1.default.bool,
    itemFontColor: prop_types_1.default.string,
    itemIconColor: prop_types_1.default.string,
    ripple: prop_types_1.default.bool,
};
exports.NavItemSharedStylePropTypes = {
    activeItemBackgroundShape: prop_types_1.default.oneOf(['round', 'square']),
    chevron: prop_types_1.default.bool,
    collapseIcon: prop_types_1.default.element,
    expandIcon: prop_types_1.default.element,
    hidePadding: prop_types_1.default.bool,
    disableActiveItemParentStyles: prop_types_1.default.bool,
    nestedBackgroundColor: prop_types_1.default.string,
    nestedDivider: prop_types_1.default.bool,
};
